import { useEffect, useState } from "react";

interface SprayButtonProps {
  isOn: boolean;
  spraying: boolean;
  onSpray: () => void;
}

export default function SprayButton({ isOn, spraying, onSpray }: SprayButtonProps) {
  const [sprayKey, setSprayKey] = useState(0);

  useEffect(() => {
    if (spraying) setSprayKey((k) => k + 1);
  }, [spraying]);

  return (
    <div className="relative rounded-xl border border-background-200 bg-background-100/60 p-3">
      <span className="flex items-center gap-2 text-sm font-medium text-foreground-800">
        <i className="ri-drop-line text-primary-500" /> 潤滑油
      </span>

      <button
        type="button"
        onClick={onSpray}
        disabled={!isOn || spraying}
        className={`mt-2 flex w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-lg py-2.5 text-sm font-semibold transition-all ${
          !isOn
            ? "cursor-not-allowed bg-background-200 text-foreground-400"
            : spraying
              ? "bg-primary-100 text-primary-600"
              : "bg-primary-500 text-background-50 hover:bg-primary-600"
        }`}
      >
        {spraying ? (
          <>
            <i className="ri-loader-4-line animate-spin" /> 噴射中
          </>
        ) : (
          <>
            <i className="ri-drop-line" /> 噴射する
          </>
        )}
      </button>

      {/* 水滴飞溅动画 */}
      {spraying && (
        <div
          key={sprayKey}
          className="pointer-events-none absolute left-1/2 top-5 -translate-x-1/2"
        >
          {[0, 1, 2, 3].map((i) => (
            <span
              key={i}
              className="spray-drop absolute h-1.5 w-1.5 rounded-full bg-primary-400"
              style={{
                left: `${(i - 1.5) * 9}px`,
                animationDelay: `${i * 0.08}s`,
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}